import variables from '../variables';

const error = {
  main: variables.themeColors.error,
};

export default error;
